import React from 'react';
import 'react-html5-camera-photo/build/css/index.css';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import {
  Button, Input,
} from 'antd';
import { faArrowLeft } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { disableNavigationAction, enableNavigationAction } from '../../../state/actions/creators/navigation.actioncreator';
import {
  addPhotoAction, uploadPhotosAction, setCurrentPhotoAction, discardCurrentPhotoAction,
} from '../../../state/actions/creators/sistemaSubidaFotografias/fotografias.actioncreator';
import Camera from '../../shared/components/Camera';
import HeaderPageLayout from '../../app/layout/headerPage.layout';
import { Box } from '../../shared/components';

class NoConformidadCamaraPage extends React.Component {
  async addPhoto(dataUri) {
    const {
      addPhotoAction, uploadPhotosAction,
      sistemaSubidaFotografias: { recursos: recursosPendientes },
    } = this.props;
    const { match: { params: { id: noConformidadId } } } = this.props;

    await addPhotoAction(noConformidadId, dataUri);
    await uploadPhotosAction(recursosPendientes);
  }

  constructor() {
    super();
    this.state = {
      searchOpened: false,
      searchText: '',
    };
  }

  getActionButtons() {
    const { logoutAction } = this.props;
    return (
      <Box>
        {/* <Button type="link" shape="circle" onClick={() => logoutAction()}>
          {' '}
          <FontAwesomeIcon icon={faSignOutAlt} />
        </Button> */}
      </Box>
    );
  }

  getNavigationButtons() {
    return (
      <Box>
        <Button type="link" shape="circle" onClick={() => this.volverAtras()}>
          {' '}
          <FontAwesomeIcon icon={faArrowLeft} />
        </Button>
      </Box>
    );
  }

  volverAtras() {
    const { history, discardCurrentPhotoAction } = this.props;
    discardCurrentPhotoAction();
    history.goBack();
  }

  render() {
    const {
      sistemaSubidaFotografias: { uploading: inProgress },
      setCurrentPhotoAction, discardCurrentPhotoAction,
    } = this.props;
    const { sistemaSubidaFotografias: { currentPhoto } } = this.props;

    return (
      <HeaderPageLayout
        title="Imágenes"
        p={2}
        navigationButton={this.getNavigationButtons()}
      >
        <Camera
          onDiscardPhoto={() => discardCurrentPhotoAction()}
          onTakePhoto={dataUri => setCurrentPhotoAction(dataUri)}
          currentPhoto={currentPhoto}
          inProgress={inProgress}
          onImageSubmit={(dataUri) => { this.addPhoto(dataUri); }}
        />
      </HeaderPageLayout>
    );
  }
}

function mapStateToProps({ sistemaSubidaFotografias }) {
  return {
    sistemaSubidaFotografias,
  };
}

function mapDispatchToProps(dispatch) {
  return bindActionCreators({
    disableNavigationAction,
    enableNavigationAction,
    addPhotoAction,
    uploadPhotosAction,
    setCurrentPhotoAction,
    discardCurrentPhotoAction,
  }, dispatch);
}

export default connect(mapStateToProps, mapDispatchToProps)(NoConformidadCamaraPage);
